import React from "react";
import { motion } from "framer-motion";
import { HiOutlineSaveAs } from "react-icons/hi";
import { Typewriter } from "react-simple-typewriter";

import { images } from "../../constants";
import { AppWrap } from "../../wrapper";

import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  return (
    <div className="relative app__header app__flex dark:bg-darktheme transition-all">
      <div className="absolute hidden sm:block w-[30%] h-[30%] top-12 right-36 dark:bg-darkCyan dark:bg-opacity-60 dark:blur-[175px]"></div>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app_header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex dark:bg-darkthemealt">
            <span>👋</span>
            <div style={{ marignLeft: 20 }}>
              <p className="p-text dark:text-gray-50">Hello, I am</p>
              <h1 className="dark:text-gray-50 font-bold">
                <Typewriter
                  words={["Hello, Iam", "Mo Lemine"]}
                  typeSpeed={150}
                  loop={1}
                  cursor
                  className="head-text dark:text-gray-50"
                />
              </h1>
              <button className="relative font-bold text-white dark:text-gray-900  ml-3 px-3 py-2 rounded-md bg_gradient dark_gradient drop_shadow transition-all hover:opacity-80">
                <a
                  className="flex items-center justify-center gap-2 text-sm"
                  href="https://drive.google.com/file/d/1VeRVFBUoZvDudrs92fGCuY4sZXm5RG_j/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  <HiOutlineSaveAs size={20} />
                  Download my CV
                </a>
              </button>
            </div>
          </div>

          <div className="tag-cmp app__flex dark:bg-darkthemealt">
            <p className="p-text dark:text-gray-50">Web Developer</p>
            <p className="p-text dark:text-gray-50">Freelancer</p>
          </div>
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        {/* <img src={images.profile} alt="profile_bg" /> */}
        {/* <ComputersCanvas /> */}
        <lottie-player
          src="https://assets4.lottiefiles.com/packages/lf20_1pxqjqps.json"
          background="transparent"
          speed="1"
          style={{ width: "100%", objectFit: "contain", zIndex: 1 }}
          loop
          autoplay
        ></lottie-player>
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="overlay_circle dark:invert dark:opacity-30"
          src={images.circle}
          alt="profile_circle"
        />
      </motion.div>
      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.redux, images.reacth, images.tailwindcss].map(
          (circle, index) => (
            <div
              className="circle-cmp app__flex dark:bg-darkthemealt"
              key={`circle-${index}`}
            >
              <img src={circle} alt="circle" />
            </div>
          )
        )}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
